import {createAction} from 'redux-actions'

const action = name => createAction(`industry-report/${name}`)

export const setStoryCount = action('SET_STORY_COUNT')
export const setStoryIdsByFactor = action('SET_STORY_IDS_BY_FACTOR')
export const setIsLoading = action('SET_IS_LOADING')
export const startDownloadPdf = action('START_DOWNLOAD_PDF')
export const finishDownloadPdf = action('FINISH_DOWNLOAD_PDF')
